import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errMsg } from "../../lib/api";

const CATS = [["complaint", "Complaint"], ["suggestion", "Programme suggestion"], ["praise", "Praise a show"], ["news_tip", "News tip"], ["advert", "Advertising enquiry"], ["technical", "Signal / technical"]];
const STATIONS = ["Peace FM", "UTV", "Okay FM", "Neat FM", "Hello FM", "Peacefmonline.com"];

export const FeedbackDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ name: "", contact: "", station: "Peace FM", category: "suggestion", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/public/feedback", f);
      toast.success(`Thank you! Routed to ${r.data.routed_to} at ${r.data.station}.`);
      setF({ ...f, message: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-[color:var(--line)]" data-testid="feedback-dialog">
        <DialogHeader><DialogTitle className="font-display text-gold">Talk to DESPITE</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-3" data-testid="feedback-form">
          <div className="grid grid-cols-2 gap-3">
            <input required className="field" placeholder="Your name" value={f.name} onChange={set("name")} data-testid="feedback-name" />
            <input required className="field" placeholder="Phone or email" value={f.contact} onChange={set("contact")} data-testid="feedback-contact" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <select className="field" value={f.station} onChange={set("station")} data-testid="feedback-station">{STATIONS.map((s) => <option key={s}>{s}</option>)}</select>
            <select className="field" value={f.category} onChange={set("category")} data-testid="feedback-category">{CATS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          </div>
          <textarea required minLength={5} rows={4} className="field" placeholder="Your message (English or Twi)" value={f.message} onChange={set("message")} data-testid="feedback-message" />
          <button disabled={busy} className="btn-gold" data-testid="feedback-submit-btn">{busy ? "Sending…" : "Send feedback"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
